module.exports = __webpack_public_path__ + "static/media/Teacher_Kids 1.63931ff8.png";